import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = ["onKeydown"]

import SIcon from 'SharedComponents/ui/Icon/SIcon.vue';
import { RouteLocationRaw, useRouter } from 'vue-router';

/**
 * Компонента, предназначенная для отображения ссылок на различные сущности
 *
 */

import { defineComponent } from 'vue';

/**
 * Добавил такую штуку только для того что бы WebStorm понимал что отсюда можно что-то
 * импортнуть, а то походу с SFC его инедксация работает не очень и не понимает что внутри
 * экспортится компонента.
 */
const __default__ = defineComponent({ name: 'EntityLink' });

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    label: {},
    active: { type: Boolean, default: true },
    deleted: { type: Boolean, default: false },
    location: {},
    showOpenInNewIcon: { type: Boolean, default: false },
    openInNewIconName: { default: 'open_in_new' },
    inverted: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();

function openInNewTab(): void {
  if (props.location === undefined) {
    return;
  }
  const resolved = router.resolve(props.location);
  window.open(resolved.href, '_blank', 'noopener,noreferrer');
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!_ctx.location)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.deleted ? 's' : 'span'), { key: 0 }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(_ctx.label), 1)
          ])
        ]),
        _: 3
      }))
    : (_ctx.active && _ctx.location && _ctx.showOpenInNewIcon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          _createVNode(_component_router_link, {
            class: _normalizeClass(["s-link s-link--font-independed", { inverted: _ctx.inverted }]),
            to: _ctx.location
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.deleted ? 's' : 'span'), null, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default", {}, () => [
                    _createTextVNode(_toDisplayString(_ctx.label), 1)
                  ])
                ]),
                _: 3
              }))
            ]),
            _: 3
          }, 8, ["class", "to"]),
          _createElementVNode("span", {
            class: "cursor-pointer inline-flex items-center q-ml-xs",
            title: "Открыть в новом окне",
            role: "button",
            tabindex: "0",
            onClick: openInNewTab,
            onKeydown: [
              _withKeys(_withModifiers(openInNewTab, ["prevent"]), ["enter"]),
              _withKeys(_withModifiers(openInNewTab, ["prevent"]), ["space"])
            ]
          }, [
            _renderSlot(_ctx.$slots, "open-in-new", {}, () => [
              _createVNode(SIcon, {
                name: _ctx.openInNewIconName,
                size: "small"
              }, null, 8, ["name"])
            ])
          ], 40, _hoisted_2)
        ]))
      : (_ctx.active && _ctx.location)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            class: _normalizeClass(["s-link s-link--font-independed", { inverted: _ctx.inverted }]),
            to: _ctx.location
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.deleted ? 's' : 'span'), null, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "default", {}, () => [
                    _createTextVNode(_toDisplayString(_ctx.label), 1)
                  ])
                ]),
                _: 3
              }))
            ]),
            _: 3
          }, 8, ["class", "to"]))
        : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.deleted ? 's' : 'span'), { key: 3 }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode(_toDisplayString(_ctx.label), 1)
              ])
            ]),
            _: 3
          }))
}
}

})